import { type NavigationTab } from '#app/components/NavigationTabs/types.js';

export const companyTabIds = [
  'overview',
  'jobs',
  'recommendations',
  'people',
  'lists',
] as const;
export type CompanyTab = NavigationTab<CompanyTabId>;
export type CompanyTabId = (typeof companyTabIds)[number];

export const INTERNAL_ONLY_WARNING_COPY =
  'Only internal team members can view this information.';
